export const ComeToYouSVG = () => {
  return (
    <svg
      className="scale-125"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.341 15.1367H12.6137V12.0117H14.8865V15.1367H17.1592V9.73899L13.7501 7.46626L10.341 9.73899V15.1367ZM13.7501 22.3526C16.0607 20.2314 17.7747 18.3043 18.8921 16.5714C20.0096 14.8384 20.5683 13.2996 20.5683 11.9549C20.5683 9.89051 19.9101 8.20017 18.5938 6.88388C17.2776 5.56759 15.663 4.90945 13.7501 4.90945C11.8372 4.90945 10.2226 5.56759 8.90634 6.88388C7.59005 8.20017 6.93191 9.89051 6.93191 11.9549C6.93191 13.2996 7.49062 14.8384 8.60804 16.5714C9.72547 18.3043 11.4395 20.2314 13.7501 22.3526ZM13.7501 25.364C10.7008 22.7693 8.42338 20.3593 6.9177 18.1339C5.41202 15.9085 4.65918 13.8488 4.65918 11.9549C4.65918 9.11399 5.57301 6.85073 7.40066 5.16513C9.22831 3.47952 11.3448 2.63672 13.7501 2.63672C16.1554 2.63672 18.2719 3.47952 20.0995 5.16513C21.9272 6.85073 22.841 9.11399 22.841 11.9549C22.841 13.8488 22.0882 15.9085 20.5825 18.1339C19.0768 20.3593 16.7993 22.7693 13.7501 25.364Z"
        fill="#3D515A"
      />
    </svg>
  );
};
